import { useEffect, useState } from "react";
import { getFileBlobUrl } from "@/lib/blobCache";
import { fileIconFor, fileCategory } from "@/lib/files";

// Renders an image thumbnail (lazily fetched as an authed blob) for image files,
// and a type icon for everything else.
export function FileThumb({ file, size = "w-9 h-9", onClick }) {
  const [src, setSrc] = useState(null);
  const isImage = fileCategory(file.original_filename, file.content_type) === "image";

  useEffect(() => {
    if (!isImage) return;
    let active = true;
    getFileBlobUrl(file.id).then(({ url }) => { if (active) setSrc(url); }).catch(() => {});
    return () => { active = false; };
  }, [file.id, isImage]);

  const clickable = onClick && isImage;
  const clickProps = clickable
    ? { onClick, role: "button", tabIndex: 0, className: "cursor-pointer hover:opacity-80 transition-opacity" }
    : {};

  if (isImage && src) {
    return (
      <img src={src} alt={file.original_filename} loading="lazy" {...clickProps}
        className={`${size} rounded-sm object-cover shrink-0 border border-gray-200 ${clickProps.className || ""}`}
        data-testid={`file-thumb-${file.id}`} />
    );
  }

  const { Icon, color } = fileIconFor(file.original_filename, file.content_type);
  return (
    <div className={`${size} rounded-sm flex items-center justify-center shrink-0 ${color}`} data-testid={`file-icon-${file.id}`}>
      <Icon className="w-[18px] h-[18px]" strokeWidth={1.8} />
    </div>
  );
}
